import { createContext, useContext } from 'react';

type TEditableContext = {
  canEdit: boolean;
};

export const EditableContext = createContext<TEditableContext>({ canEdit: true });

export const useEditable = () => useContext(EditableContext);
